import { atom, useAtom } from "jotai";
import { MessagingThreadFailedActionMenuAction } from "./MessagingThreadFailedActionMenu.types";
import { s } from "../../../lib/styler";
import Icon from "../../commons/Icon";
import MessagingThreadFailedActionMenuItem from "./MessagingThreadFailedActionMenu/MessagingThreadFailedActionMenuItem";
import { useCallback } from "react";
import { serviceSync } from "../../../services/sync.service";

export type MessagingThreadFailedActionMenuProps = {
}

export default function MessagingThreadFailedActionMenu({ }: MessagingThreadFailedActionMenuProps) {
    const [{ cb }, setMenuAtom] = useAtom(serviceSync.atomMessagingThreadFailedActionMenu);

    const closeHandler = useCallback(() => {
        setMenuAtom({});
    }, []);

    const itemClickHandler = useCallback((action: MessagingThreadFailedActionMenuAction) => {
        cb?.(action);
        setMenuAtom({});
    }, [cb]);

    return (
        <div className={s(`absolute left-0 top-0 w-full h-full transition-opacity duration-200 bg-black/25 flex justify-center items-center cursor-pointer`, {}, [
            ["opacity-100", "opacity-0 pointer-events-none", !!cb]
        ])} onClick={closeHandler}>
            <div className="bg-gray-200 rounded-[10px] overflow-hidden">
                <MessagingThreadFailedActionMenuItem iconName="bx-refresh" text="Retry" border onClick={() => itemClickHandler("Retry")} />
                <MessagingThreadFailedActionMenuItem iconName="bx-trash" text="Delete" onClick={() => itemClickHandler("Delete")} />
            </div>
            <div className="absolute right-[10px] top-[10px] text-gray-100 hover:text-gray-300 p-[10px] cursor-pointer duration-200 transition-colors" onClick={closeHandler}>
                <Icon name="bx-x" size="30px" />
            </div>
        </div>
    );
}